var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSauron(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 331.847,
    height: 544.546,
    viewBox: "0 0 89.947 147.599",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(139.73 -173.498)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: -94.692,
    cy: 303.068,
    fill: "#c6cab7",
    fillRule: "evenodd",
    paintOrder: "markers stroke fill",
    rx: 34.466,
    ry: 12.608
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02141f",
    fillRule: "evenodd",
    d: "M-114.445 208.345v7.87h4.833l-8.873 87.778 47.586-.361-9.016-87.417h3.98v-7.87z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#02141f",
    d: "M-134.308 275.934l19.04 28.059 4.272-6.582zM-130.668 228.65l19.04 28.059 4.273-6.582zM-131.32 187.412l19.04 28.058 4.272-6.581zM-55.203 275.56l-19.04 28.06-4.273-6.582zM-58.756 228.65l-19.04 28.059-4.273-6.582zM-59.178 187.412l-19.04 28.058-4.273-6.581z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#083350",
    fillRule: "evenodd",
    d: "M-87.529 294.15a3.724 3.724 0 00-3.718 3.724 3.724 3.724 0 00.101.859v4.997h7.298v-4.997h-.05a3.724 3.724 0 00.1-.859 3.724 3.724 0 00-3.724-3.724 3.724 3.724 0 00-.007 0z",
    paintOrder: "stroke fill markers"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff4d2f",
    d: "M-95.776 178.919c-13.451-.05-24.277 13.086-24.12 13.117-.16.032 11.015 13.588 24.762 13.105 10.114-.355 16.809-3.104 25.648-13.009-8.84-9.905-15.534-12.845-25.648-13.2a19.457 19.457 0 00-.642-.013z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff9946",
    d: "M-95.541 181.759c-10.54-.04-19.021 10.253-18.898 10.277-.125.026 8.63 10.646 19.401 10.268 7.924-.278 13.17-2.432 20.095-10.193-6.926-7.76-12.171-10.064-20.095-10.342a16.968 16.968 0 00-.503-.01z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -94.692,
    cy: 192.036,
    fill: "#031420",
    fillRule: "evenodd",
    paintOrder: "stroke fill markers",
    rx: 2.533,
    ry: 9.983
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSauron);
export default __webpack_public_path__ + "static/media/sauron.8438a6fe.svg";
export { ForwardRef as ReactComponent };